import * as React from 'react';
import { RootState } from 'Redux/Reducers/_RootReducer';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { SpeedDataTimeGroup, CarSpeedDataframeDto ,ActiveSpeedDataTimeGroup} from 'Models/CollisionModel';
import { HistoryCollisionSelectors } from 'Redux/Selectors/CollisionSelectors';
import {setActiveCollisionDataframes} from 'Redux/Actions/CollisionActions';
import {PlayerStatusEnum,SpeedMultiplierEnum} from './CollisionTimeLineEnums';
import {HistoryTimeLine} from './HistoryTimeLine';
import {HistoryTimeLineCells} from './HistoryTimeLineCells';
import {HistoryTimeLineLabel} from './HistoryTimeLineLabel';

type Props = {
    history?:any,
    t?:any
};

type ConnectedProps = {
    speedDataTimeGroup:Array<SpeedDataTimeGroup>,
    activeDataFrameDataTime:string,
    activeSpeedDataTimeGroup:ActiveSpeedDataTimeGroup,
    activeDataFrameObj:CarSpeedDataframeDto
};

interface IDispatchedP {
    setActiveDataframe:(activeDataFrameDataTime:string)=>any
}

export class CollisionTimeLineContener extends React.Component<Props & ConnectedProps & IDispatchedP,any> {;

    constructor(props:any) {
        super(props);
        this.state = {
            playerStatus:PlayerStatusEnum.STOP,
            interval:null,
            speedMultiplier:SpeedMultiplierEnum.SPEED1
        }

        this.playDataframe = this.playDataframe.bind(this);
        this.pauseDataframe = this.pauseDataframe.bind(this);
        this.playFastDataframe = this.playFastDataframe.bind(this);
        this.playSlowDataframe = this.playSlowDataframe.bind(this);
        this.setActiveDataframe = this.setActiveDataframe.bind(this)
    }

    private playDataframe() {
        const {activeSpeedDataTimeGroup:{activeGroupIndex,activeElementInGroupIndex}} = this.props;
        this.playInterval(activeGroupIndex,activeElementInGroupIndex);
        this.setState({playerStatus:PlayerStatusEnum.PLAY})
    }

    private getSpeedMultiplier() {
        switch(this.state.speedMultiplier) {
            case SpeedMultiplierEnum.SPEED05:
                return 2;
            case SpeedMultiplierEnum.SPEED1:
                return 1;
            case SpeedMultiplierEnum.SPEED2:
                return 0.5; 
            default:
                return 1;              
        }
    }

    private clearIntervalDataframe() {
        clearInterval(this.state.interval);
        this.setState({interval:null})
    }

    private playInterval(groupNumber = 0,frame = 0) {
        this.clearIntervalDataframe();
        const speedDataTimeGroup = this.props.speedDataTimeGroup[groupNumber];

        if(speedDataTimeGroup) {
            const speed = 1000/speedDataTimeGroup.dataframes.length*this.getSpeedMultiplier();
            let j = frame;
            const intervalTemp = setInterval(() => { 
                this.props.setActiveDataframe(speedDataTimeGroup.dataframes[j].dateTime);
                if(!speedDataTimeGroup.dataframes[j+1]) {
                    this.playInterval(groupNumber+1);
                }
                j++;
            }, speed);
    
            this.setState({interval:intervalTemp})
        } else {
           this.pauseDataframe(); 
        }
    }

    private pauseDataframe() {
        this.clearIntervalDataframe();
        this.setState({playerStatus:PlayerStatusEnum.STOP})
    }

    private async setActiveDataframe(el:CarSpeedDataframeDto) {
        this.pauseDataframe();
        await this.props.setActiveDataframe(el.dateTime);
    }

    private playFastDataframe() {
        const speedType = (this.state.speedMultiplier == SpeedMultiplierEnum.SPEED2)?SpeedMultiplierEnum.SPEED1:SpeedMultiplierEnum.SPEED2;
        this.setState({speedMultiplier:speedType},()=> {
            this.pauseDataframe();
            this.playDataframe();
        })
    }

    private playSlowDataframe() {
        const speedType = (this.state.speedMultiplier == SpeedMultiplierEnum.SPEED05)?SpeedMultiplierEnum.SPEED1:SpeedMultiplierEnum.SPEED05;
        this.setState({speedMultiplier:speedType},()=> {
            this.pauseDataframe();
            this.playDataframe();
        })
    }

    public render() {

        const {activeDataFrameDataTime,activeDataFrameObj,speedDataTimeGroup} = this.props;
        return (
                <>
                {   activeDataFrameObj && 
                    <HistoryTimeLine>
                        <HistoryTimeLineLabel 
                            playSlowDataframe={this.playSlowDataframe}
                            playDataframe={this.playDataframe} 
                            pauseDataframe={this.pauseDataframe}
                            playFastDataframe={this.playFastDataframe}
                            speedGps={activeDataFrameObj.speedGps}
                            acceleration={activeDataFrameObj.acceleration}
                            dateTime={activeDataFrameObj.dateTime}
                            speedMultiplier={this.state.speedMultiplier}
                            playerStatus={this.state.playerStatus}
                        />

                        <HistoryTimeLineCells 
                            speedDataTimeGroup={speedDataTimeGroup}
                            setActiveDataframe={this.setActiveDataframe}
                            activeDataFrameDataTime={activeDataFrameDataTime}    
                        />
                    </HistoryTimeLine>
                }
                </>
            )
    }
}

function mapStateToProps(state: RootState): ConnectedProps {
    return {
      speedDataTimeGroup:HistoryCollisionSelectors.getSpeedDataTimeGroup(state),
      activeDataFrameDataTime:state.historyCollision.activeDataframes,
      activeDataFrameObj:HistoryCollisionSelectors.getActiveSpeedDataframe(state),
      activeSpeedDataTimeGroup:HistoryCollisionSelectors.getActiveSpeedDataTimeGroup(state)
    };
}

function mapDispachToProps(dispatch: any): IDispatchedP {
  return {
    setActiveDataframe:(dateTime:string)=>dispatch(setActiveCollisionDataframes(dateTime))
  };
}

export default withTranslation(['reports'])(connect(
    mapStateToProps,
    mapDispachToProps
)(CollisionTimeLineContener) as React.ComponentClass<any>);



// WEBPACK FOOTER //
// ./src/components/History/CollisionTimeLine/CollisionTimeLine.tsx